module.exports = __webpack_public_path__ + "static/media/deck-3-super.af8e9279.png";